import React from 'react';
import {useIntl} from 'react-intl';

import Typography from 'brandComponents/Typography';

import messages from './messages';

import styles from './ProductHitWishlistInfo.module.scss';

const ProductHitWishlistInfo = ({color, size}) => {
	const intl = useIntl();

	return (
		<div className={styles['wishlist-info']}>
			<Typography variant="p">
				{intl.formatMessage(messages.color)}{color}
			</Typography>
			<Typography variant="p">
				{intl.formatMessage(messages.size)}{size}
			</Typography>
		</div>
	);
};

export default ProductHitWishlistInfo;
